import './EmptyPageBacksplash.pcss';
import React from 'react';

type Props = {
  pageIcon: string;
  children: React.ReactNode | string;
};

const EmptyPageBacksplash = (props: Props) => {
  const { pageIcon, children } = props;

  return (
    <div className="empty-page-backsplash">
      <img
        src={pageIcon}
        alt="Empty Page Icon"
        className="empty-page-backsplash__page-icon"
      />

      <div className="empty-page-backsplash__bottom-area">{children}</div>
    </div>
  );
};

export default EmptyPageBacksplash;
